module.exports = __webpack_public_path__ + "static/media/contact_banner.ed7cdcb2.jpg";